import { useState } from 'react';
import { useMount } from 'ahooks';
import { getQueryDefinition } from '@intelligence/services/common';

import type { TReportConfigMap } from '@intelligence/utils/reportConfig';

/** 获取报告级配置 */
export const fetchReportConfig = async (): Promise<TReportConfigMap> => {
  try {
    const res = await getQueryDefinition({
      common: {
        target: 'game_config',
        params: { key: 'intelligence_report_config' },
      },
    });
    const config = res?.data?.common?.intelligence_report_config;
    return Object.prototype.toString.call(config) === '[object Object]' ? config : {};
  } catch (error) {
    console.error('[ReportConfig] fetch config failed:', error);
    return {};
  }
};

/** 获取报告级配置 */
export const useReportConfig = (): TReportConfigMap => {
  const [config, setConfig] = useState<TReportConfigMap>({});

  useMount(async () => {
    const configTmp = await fetchReportConfig();
    setConfig(configTmp);
  });

  return config;
};
